export const TEST_ID = 'mapProvider';
